import { createAction } from 'redux-actions';

/**
 * @template {any} T
 * @typedef {object} ModalState
 * @property {boolean} show
 * @property {number} size
 * @property {T} props
 */

export const openAction = createAction('@@modal/OPEN_MODAL');
export const closeAction = createAction('@@modal/CLOSE_MODAL');

export const openModal = (name, props = {}, size = 600) =>
  openAction({ name, props, size });
export const closeModal = (name) => closeAction({ name });
export const clearModal = createAction('@@modal/CLEAR_MODAL');


/**
 * @template {any} T
 * @param {*} state
 * @param {*} name
 * @returns {ModalState<T>}
 */
export const getModal = (state, name) => state.modal[name] || {};

export const isTopModal = (state, name) => {
  const stack = state.modal.stack ?? [];
  return stack[stack.length - 1] === name;
};